module.exports = __webpack_public_path__ + "static/media/1021529.34bd773e.jpg";